<template>
  <v-layout
    v-if="isFailed"
    :style="`height: ${height}px;`"
    align-center
    justify-center
    fill-height
  >
    <span class="text--small text--center">
      {{ $t('Common.boxGenericError') }}<br>
      <a :title="$t('Common.tryAgain')" @click.prevent="tryAgain">
        {{ $t('Common.tryAgain') }}
      </a>
    </span>
  </v-layout>
</template>

<script>
import { STATUS_FAILED } from 'utils/constants'

export default {
  name: 'Error',
  props: {
    status: {
      type: Number
    },
    height: {
      type: [String, Number]
    }
  },
  computed: {
    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  methods: {
    tryAgain () {
      this.$emit('tryAgain')
    }
  }
}
</script>
